import { css } from 'styled-components';
import { map } from '../../breakpoint';
import { pickBorderColor } from './colors';
export const validBorderStyleValues = ['none', 'hidden', 'dotted', 'dashed', 'solid', 'double', 'groove', 'inset', 'ridge', 'outset'];
export const validBorderWidthValues = ['none', 'fine', 'thin', 'medium', 'thick'];
export const border = () => css`
  ${_ref => {
  let {
    borderColor
  } = _ref;
  return map(borderColor, color => color && css`
          border-color: ${pickBorderColor(color)};
        `);
}};

  ${(_ref2 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    borderWidth
  } = _ref2;
  return map(borderWidth, val => val !== undefined && css`
          border-width: ${validBorderWidthValues.includes(val) ? pickBorderWidth(val) : val};
        `);
}};

  ${(_ref3 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    borderStyle
  } = _ref3;
  return map(borderStyle, val => val && css`
          border-style: ${val};
        `);
}};
`;
const VALID_TOKEN_BORDER_WIDTH_VALUES = {
  none: `var(--themeDimensionBorderWidthNone)`,
  fine: `var(--themeDimensionBorderWidthFine)`,
  thin: `var(--themeDimensionBorderWidthThin)`,
  medium: `var(--themeDimensionBorderWidthMedium)`,
  thick: `var(--themeDimensionBorderWidthThick)`
};
export const pickBorderWidth = borderWidth => {
  switch (borderWidth) {
    case 'none':
      return VALID_TOKEN_BORDER_WIDTH_VALUES.none;
    case 'fine':
      return VALID_TOKEN_BORDER_WIDTH_VALUES.fine;
    case 'thin':
      return VALID_TOKEN_BORDER_WIDTH_VALUES.thin;
    case 'medium':
      return VALID_TOKEN_BORDER_WIDTH_VALUES.medium;
    case 'thick':
      return VALID_TOKEN_BORDER_WIDTH_VALUES.thick;
  }
};